import { render, staticRenderFns } from "./Compra.vue?vue&type=template&id=97e897ec&scoped=true"
import script from "./Compra.vue?vue&type=script&lang=js"
export * from "./Compra.vue?vue&type=script&lang=js"
import style0 from "./Compra.vue?vue&type=style&index=0&id=97e897ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97e897ec",
  null
  
)

export default component.exports